import KeenSlider from 'keen-slider';
import 'keen-slider/keen-slider.min.css';
import debounce from 'debounce';

// for the slider inside the prefooter block
document.addEventListener('DOMContentLoaded', function () {
  class BlockTeam extends HTMLElement {
    constructor() {
      super();
      // elements
      this.keenSliders = [];
      this.sliders = Array.from(this.querySelectorAll('.keen-slider'));
      this.switchSelector = '.js-team__switch';
      this.navSelector = '.js-team__nav';
      this.listSelector = '.js-team__list';
      this.prevSelector = '.js-team__prev';
      this.nextSelector = '.js-team__next';
    }
    connectedCallback() {
      // bindings
      this.bndHandleResize = debounce(this.handleResize.bind(this), 100);
      this.bndHandleClick = this.handleClick.bind(this);
      // events
      this.onLoad();
      window.addEventListener('resize', this.bndHandleResize);
      window.addEventListener('click', this.bndHandleClick);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.bndHandleResize);
      window.removeEventListener('click', this.bndHandleClick);
      this.keenSliders.forEach(slider => {
        if (slider.destroy) slider.destroy();
      });
    }
    onLoad() {
      this.initSliders();
    }
    handleClick(event) {
      const switchTrigger = event.target.closest(this.switchSelector);
      if (switchTrigger) this.switchSlider(switchTrigger, event);
    }
    handleResize() {
      this.keenSliders.forEach(slider => {
        this.toggleActiveSlide(slider);
      });
    }
    switchSlider(trigger, event) {
      event.preventDefault();
      const target = this.querySelector(trigger.getAttribute('href'));
      const siblings = this.querySelectorAll(this.switchSelector);
      const lists = this.querySelectorAll(this.listSelector);
      siblings.forEach(sibling => {
        sibling.removeAttribute('aria-current');
      });
      lists.forEach(list => {
        list.setAttribute('hidden', '');
      });
      trigger.setAttribute('aria-current', 'true');
      target.removeAttribute('hidden');
      const nav = this.querySelector(this.navSelector);
      const navLeftPosition = nav.getBoundingClientRect().left ?? 0;
      const triggerLeftPosition = trigger.getBoundingClientRect().left ?? 0;
      this.style.setProperty('--translate--team-marker', `${triggerLeftPosition - navLeftPosition}px`);
    }
    initSliders() {
      if (this.sliders.length < 1) return;
      this.handleResize();
      this.sliders.forEach((slider, index) => this.initSlider(slider, index));
    }

    // tag the first visible slide because the indexes are not reliable with loop
    toggleActiveSlide(slider) {
      if (!slider?.slides) return;
      slider.slides.forEach(slide => {
        slide.removeAttribute('data-current-mobile');
        slide.removeAttribute('data-current-desktop');
      });
      const mobileVisibleIndex = slider.track.absToRel(slider.track.details.abs);
      const mobileVisibleSlide = slider.slides[mobileVisibleIndex];
      mobileVisibleSlide.setAttribute('data-current-mobile', 'true');
    }
    initSlider(el, index) {
      if (!el) return;
      this.keenSliders[index] = new KeenSlider(el, {
        slides: {
          perView: 1.15,
          spacing: 20
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.15,
              spacing: 20
            }
          },
          '(min-width: 992px)': {
            slides: {
              perView: 4.15,
              spacing: 20
            }
          }
        }
      }, [slider => {
        const next = slider.container.closest(this.listSelector).querySelector(this.nextSelector);
        const prev = slider.container.closest(this.listSelector).querySelector(this.prevSelector);
        const hideInfos = () => {
          slider.container?.classList.add('is-animated');
        };
        const showInfos = () => {
          slider.container?.classList.remove('is-animated');
        };
        const refreshArrows = slider => {
          const details = slider.track.details;
          const current = details?.rel ?? 0;
          prev?.removeAttribute('disabled');
          next?.removeAttribute('disabled');
          if (current === 0) {
            prev?.setAttribute('disabled', 'disabled');
          }
          if (current >= details.maxIdx) {
            next?.setAttribute('disabled', 'disabled');
          }
        };
        slider.on('created', () => {
          slider.container?.classList.add('is-ready');
          this.toggleActiveSlide(slider);
          refreshArrows(slider);
          prev?.addEventListener('click', () => {
            slider.prev();
          });
          next?.addEventListener('click', () => {
            slider.next();
          });
        });
        slider.on('animationEnded', () => {
          showInfos();
        });
        slider.on('slideChanged', () => {
          this.toggleActiveSlide(slider);
          hideInfos();
          refreshArrows(slider);
        });
        slider.on('updated', () => {
          this.toggleActiveSlide(slider);
          refreshArrows(slider);
        });
      }]);
    }
  }
  customElements.define('block-team', BlockTeam);
});